import { FC } from 'react';

import { useFlags } from '../../../../shared/contexts/LDContext';
import { ErrorBoundary } from '../../../../shared/utils/errorReporting/ErrorBoundary';
import { RIDE_STATES } from '../../../constants/rideStates';
import { RideDetails } from '../../../types/rides';
import { InfoNavContent } from '..';

import { DriverDetails, DriverDetailsSkeleton } from './DriverDetails/DriverDetails';
import { NoDriver } from './NoDriver/NoDriver';
import { InCartDriver } from './InCartDriver';

interface RideDetailsProps {
  rideDetails: RideDetails;
}

export const DriverDetailsTab: FC<RideDetailsProps> = ({ rideDetails }) => {
  const { enableOssCarePartnerRideDetails } = useFlags();

  return (
    <InfoNavContent>
      {rideDetails?.driverSlug ? (
        <ErrorBoundary
          FallbackComponent={() => <DriverDetailsSkeleton accountType={rideDetails.accountDetails.accountType} />}
        >
          {!enableOssCarePartnerRideDetails && rideDetails.inCart ? (
            <InCartDriver rideDetails={rideDetails} />
          ) : (
            <DriverDetails
              rideState={rideDetails.state}
              accountType={rideDetails.accountDetails.accountType}
              isCarePartnerRide={enableOssCarePartnerRideDetails && rideDetails?.isCarePartnerRide}
            />
          )}
        </ErrorBoundary>
      ) : (
        <NoDriver
          adminRideUrl={rideDetails?.adminRideUrl}
          isCanceledOrInactive={[...RIDE_STATES.canceled, ...RIDE_STATES.inactive].includes(rideDetails?.state)}
          isCarePartnerRide={enableOssCarePartnerRideDetails && rideDetails?.isCarePartnerRide}
        />
      )}
    </InfoNavContent>
  );
};
